import styled, { css } from 'styled-components'
import { space, layout, position, flexbox, grid, padding, opacity } from 'styled-system'

import { IBox } from './types'

export const withBox = css`
  ${space}
  ${layout}
  ${flexbox}
  ${grid}
  ${position}
  ${opacity};
  ${padding};
`

const Box = styled.div<IBox>`
  ${withBox}
`

export default Box
